export const userRoleProfileData = `<p>&nbsp;&nbsp;</p>
<p>There are different types of role profiles and users for Lloyds Bank Gem Connect.</p>
<p>Four role profiles are set up as part of the initial company set up on Lloyds Bank Gem Connect and they are as follows:</p>
<p><strong>Primary Administrators</strong> (or “Super Users”) are the Primary and Secondary role profiles that are set up by the Onboarding &amp; Servicing Team and are linked to the top-level division in the client hierarchy. Two Users from the company are assigned to these roles at set up.</p>
<p>The Primary Administrators will be automatically added to every legal entity in the company hierarchy. This includes child and grandchild legal entities. You can remove the Primary Administrator from a legal entity (s) in the Admin > Company > Administration screen.</p>
<p>They are able to perform Admin functions on all users within the business. There must be a minimum of 2 Primary Admins at any given time. It is recommended that more than 2 Primary Admins are assigned, in order to ensure approvals can still be carried out during times of holiday, sickness or leave.</p>
<p>If an existing or new user is added to the Primary Administrator role, they will also be automatically added as a Primary Administrator to all legal entities (child and grandchild) in the company hierarchy, below the level in the hierarchy to which they are assigned. They do not have administrator entitlement to legal entities above them (parent) or to entities across the hierarchy (siblings).</p>
<p>Note that if a new company is added to the company hierarchy, The Primary Administrators of the parent company will be added to new legal entity.</p>
<p><strong>Administrator </strong> (or “Admin”) is a pre canned role profile created during set up that can be assigned to a User to provide individual company employee(s) with additional capabilities in order to manage other users within their business division or Company. They can create user role profiles as well as being able to view, edit, delete, clone and display user role profiles and approve or reject various requests.</p>
<p><strong>Balance and Reporting </strong> is the second pre canned role profile created during set up that can be assigned to a User to provide specific balance and reporting capabilities.</p>
<p>The following types of users are also available as part of your Lloyds Bank Gem Connect set up:</p>
<p><strong>Users</strong> are individual company employees that are created by admin role profile users and are assigned to a specific role profile during set up that defines their level of access to Lloyds Bank Gem Connect. Once the user creation (role profile assignment and entitlements) has been completed they can be given the necessary permissions and functionality to carry out specific activities within Lloyds Bank Gem Connect.</p>
<p><strong>System users - this is only required where you are using an unattended channel.</strong> This type of user should be set up to allow your Lloyds Bank unattended channel services (e.g. Commercial Banking Direct, API etc.) to connect to specific accounts held in LLOYDS BANK to make payments. Further information on system users is in <strong>System users</strong> section.</p>
<p>The table below is a summary of activity required to progress from initial set up into users being able to perform their daily role activities.</p>
<table style="width:100%;border:1px">
<tr style="border:1px solid">
<th style="border:1px solid;padding:5px">Step</th>
<th style="border:1px solid;padding:5px">Activity</th>
<th style="border:1px solid;padding:5px">Owner</th>
<th style="border:1px solid;padding:5px">Description</th>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">1</td>
<td style="border:1px solid;padding:5px">Onboard Customer</td>
<td style="border:1px solid;padding:5px">Onboarding & Servicing Team</td>
<td style="border:1px solid;padding:5px">1. Enable Primary, Secondary, Admin and B&R role profiles </br>
2. Assign a single User to both Primary and Secondary role profiles </br>
3. Link all open accounts to customer set up</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">2</td>
<td style="border:1px solid;padding:5px">Admin User initial access to Lloyds Bank Gem Connect</td>
<td style="border:1px solid;padding:5px">Admin User (Primary and Secondary role profiles)</td>
<td style="border:1px solid;padding:5px">1. Complete account activation process </br>
2. Login to Lloyds Bank Gem Connect and complete ID authentication </br>
3. Link all relevant open accounts to User role profile  </td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">3</td>
<td style="border:1px solid;padding:5px">Assign Users to role profiles</td>
<td style="border:1px solid;padding:5px">Admin User (Primary and Secondary role profiles)</td>
<td style="border:1px solid;padding:5px">1. Create Users and link to pre-defined Admin and B&R Profiles</br>
2. Create any new ad-hoc role profiles as required </br>
- Select Division/Entity Level </br>
- Select Channel for use with role profile </br>
- Select Account entitlements </br>
- Select Feature entitlements </br>
3. Create any additional users and assign to new ad-hoc role profiles</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">4</td>
<td style="border:1px solid;padding:5px">Non-Admin User initial access to Lloyds Bank Gem Connect</td>
<td style="border:1px solid;padding:5px">Non-Admin User (B&R and any ad-hoc role profiles)</td>
<td style="border:1px solid;padding:5px">1. Complete account activation process </br>
2. Login to Lloyds Bank Gem Connect and complete ID authentication </br>
3. Link all relevant open accounts to User role profile</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">5</td>
<td style="border:1px solid;padding:5px">Additional Feature and Service enablement</td>
<td style="border:1px solid;padding:5px">Admin User (Primary, Secondary and Admin role profiles)</td>
<td style="border:1px solid;padding:5px">1. Identify any specific activities or functions required for role profiles (Payment Approvals, Account Opening, Reporting Capability) </br>
2. Follow relevant instructions to enable each additional activity or function (e.g. Payment approval as defined in <a href='javascript:void(0)' data-link='paymentsFunctionality'>Payments </a>section of this document)</td>
</tr>
</table>
`;

export const addProfile = `<p class='underline'><strong>Add user role profile&nbsp;</strong></p>
<p>User entitlements will be set by Admins creating a user role profile.</p>
<p> Select Admin > User Role Profiles and then and click <strong>Add Profile </strong>at the top right of the table.</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/1.png'/></p>
<p>Input the <strong>profile name</strong>, select the required <strong>Entity </strong> level and add a <strong>description </strong>(optional).</p>
<p>Please note that the Entity level selected will determine what access and information is made available to any Users who are linked to this role profile. In general terms, the entity level selected allows the user to see all info for that level and any company/division below that as well.</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/2.png'/></p>
<p>Next, select Web in <strong> Supported channels </strong> to provide access to Lloyds Bank Gem Connect.</p>
<p>When selecting the Web channel, a Profile template must also be selected.  Once the Web Channel has been ticked a dropdown is displayed and gives a choice of template roles that determine the initial feature entitlements that will be pre-selected for the new profile.</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/14.png'/></p>
<p>A template must be chosen from the list for the profile to be created.  The choices available are
<ul>
<li>Admin – includes access to all feature entitlements.</li>
<li>Payments and reporting – No Admin entitlements are included. Gives access to all Payments, Approval, Virtual Account and Reporting entitlements</li>
<li>Payments – No Admin or Approval entitlements are included.  Gives access to make payments, virtual account and reporting entitlements.</li>
<li>Approver – No Admin, Payments or Virtual Account entitlements.  Gives access to Approvals and Reporting entitlements</li>
<li>Reporting – No Admin , Payments, Approval and Virtual Account entitlements.  Gives access to Reporting and Statements only.</li>
</ul>
Once a role is created with the template entitlements it can be amended via the Edit process will all entitlements available to be added.
</p>
<p>Ensure you select either <strong> “Active” </strong> or  <strong>“Inactive” </strong> within Profile status before moving on. If an Admin sets a profile to inactive, the user has been added to that profile, but they will be unable to log on to Lloyds Bank Gem Connect. Therefore, Administrators must ensure the profile is Active to enable user access.</p>
<p>Click <strong>Add, Save </strong>then <strong> Done </strong>to complete the action, <strong>Reset</strong> to start again, or <strong>Cancel </strong>to cancel the action.</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/3.png'/></p>
<p>When you add a User role profile, it does not need approving. However, when you add accounts or maintain the functional entitlements then they need to be approved.</p>
<p>Next, you will need to select the relevant entitlements by channel. To do this you must click Edit against the user profile created, as described in Edit user role profile section.</p>
`

export const editProfile = `<p class='underline'><strong>Edit User Role Profile&nbsp;</strong></p>
<p>Once the above role creation has been completed you will be placed back to the role profile summary screen. Use the three-dot symbol beside an existing profile to select <strong> Edit </strong>. 
You will be able to update the profile name, entitlements selected, description and supported channels.<strong> Note the Legal entity the user role profile is assigned to cannot be amended.</strong></p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/4.png'/></p>
<p><strong>Account Entitlements</strong></p>
<div class='row'>
<div class='col-4'>
<p>You will need to add account entitlements by each channel by clicking on the <strong>padlock symbol</strong>.</p>
<p>Only one channel can be selected per profile.</p>

<p>For example, if the user role profile has Web channel access, click on the padlock next to the Web to see their entitlements. These are split between Account and Feature entitlements.</p>
</div>
<div class='col-8'>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/7.png'/></p>
</div>
</div>
<p>The Web padlock should be used for Lloyds Bank Gem Connect entitlements only.</p>
<p>Please note that “CBD” provides entitlements to the host-to-host channel Lloyds Bank Gem Direct.</p>
<p>For an Admin user role profile all entitlements should be enabled, including all administration entitlements.</p>

<p><img src='${process.env.PUBLIC_URL}/images/2/1/8.png'/></p>
<p>&nbsp;&nbsp;</p>
<p>Admins must select the specific accounts in order to enable user access, or click <strong>Select all</strong> to grant access to all available accounts within an entity. If the number of accounts available exceeds 1 page, please make sure to review each page of accounts to select those required.</p>
<p>Admins have the ability to enable entitlements for Users so that newly created accounts in each user profile are automatically added.&nbsp;</p>
<p>Click on <strong>Next permissions</strong> at the bottom right of the page or select <strong>Feature Entitlements</strong> from the Entitlements dropdown at the top.</p>
<hr/>
<p><strong>Feature Entitlements</strong></p>
<p>Feature entitlements allow Admins to manage users permission to access various functionality such as making payments, viewing transactions and balances, reporting and/or Administration features.</p>
<p>Entitlements can be added under each tab by clicking on the individual selection boxes, or the Select all button. <strong>Unselect any entitlements </strong> which are not applicable to the user profile. &nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/9.png'/></p>
<p>&nbsp;&nbsp;</p>
<p>Click <strong>Save</strong> on each page where changes have been made to complete the update (<strong>please</strong> <strong>note</strong> <strong>you will need to press save</strong> <strong>twice </strong>– 
  a banner should appear at the top of the page confirming all changes have been saved).</p>
<p>&nbsp;&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/10.png'/></p>
<p>Alternatively, <strong>Cancel</strong> the action or go <strong>Back</strong> to the Edit Entitlement Profile page.</p>
<p>Note that if the role is already assigned to one or more users, any change to user role profiles will need to be approved by another administrator.</p>
<p>&nbsp;&nbsp;</p>`;

export const deleteProfile = `<p class='underline'><strong>Delete User Role Profile</strong></p>
<div class='row'>
<div class='col-6'>
<p>User role profiles with one or more users assigned cannot be deleted. If there are no users assigned to a user role profile click <strong>Delete</strong>. A pop-up window appears to ask you to confirm the action or gives you further instruction. 
Upon clicking Delete, the user role profile is removed as an option for Administrators.</p>
</div>
<div class='col-4'>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/11.png'/></p>
</div>
</div>

`;

export const viewProfile = `<p class='underline'><strong>View User Role Profile</strong></p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/11.png'/></p>
<p>To view details of an existing profile, use the three-dot symbol to click <strong>View</strong> beside the profile. The details will appear in a pop-up window. Click <strong>Done </strong>to close the window and return to the main page.</p>`;

export const cloneProfile =  `<p><strong>Clone</strong></p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/11.png'/></p>
<p>By selecting <strong>Clone</strong> you can duplicate existing user role profiles to reduce setup and configuration time and then edit as required.&nbsp;</p>`;

export const listUsers = `<p><strong>List Users&nbsp;</strong></p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/11.png'/></p>
<p>Use the three-dot symbol to click <strong>List Users </strong>beside the profile, you will be able to view a summary list of users. Click <strong>Done </strong>to close the window and return to the main page.</p>
<p><strong>Transaction Limit Entitlements</strong></p>
<p><u>Channel Approvals</u></p>
<p>The user role profile configuration includes transaction and daily limits for API, CBD or SWIFT channels. These entitlements can be used to either reject payments over a certain value or push transactions into the existing GEM Connect payment approval process.</p>
<p>The two types of limits that can be set are per transaction or per day. These are defined within the role profile and if required are set on an individual channel basis, API, CBD or SWIFT.</p>
<p>Whether these are set within the channel role profile is optional however as soon as they are set all payments that are initiated via that channel will be assessed against the limit and processed accordingly.</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/12.png'/></p>
<p><u>Per Transaction Limits</u></p>
<p>Once the per transaction limit has been set and a payment file submitted via the specific unattended channel route, we will check whether any transactions breach the limit. The way these transactions are treated is shown in the table below.</p>
<table class='table table-bordered'>
<tbody>
<tr>
<td valign="top" width="94" class='table-background'>
<p><strong>Limit</strong></p>
</td>
<td valign="top" width="94" class='table-background'>
<p><strong>Exceed with Approval Set</strong></p>
</td>
<td valign="top" width="123" class='table-background'>
<p><strong>Single Debit (SD) or Single Debit/Multi Credit (SD/MC)</strong></p>
</td>
<td valign="top" width="290" class='table-background'>
<p><strong>Treatment</strong></p>
</td>
</tr>
<tr>
<td valign="top" width="94"  >
<p>Transaction limit breached</p>
</td>
<td valign="top" width="94" >
<p>No</p>
</td>
<td valign="top" width="123" >
<p>SD</p>
</td>
<td valign="top" width="290" >
<p>Transaction Rejected</p>
</td>
</tr>
<tr>
<td valign="top" width="94" >
<p>Transaction limit breached</p>
</td>
<td valign="top" width="94" >
<p>Yes</p>
</td>
<td valign="top" width="123" >
<p>SD</p>
</td>
<td valign="top" width="290" >
<p>Transaction sent for in channel approval via the existing Transaction Approval screen.&nbsp;</p>
</td>
</tr>
<tr>
<td valign="top" width="94" >
<p>Transaction limit breached</p>
</td>
<td valign="top" width="94">
<p>No</p>
</td>
<td valign="top" width="123" >
<p>SD/MC</p>
</td>
<td valign="top" width="290" >
<p>Transaction Rejected</p>
<p><em style="color:#7CB9E8">Note: The debit amount, i.e., the combined total for that specific SD/MC transaction will be used to calculate the transaction amount for limit checking purposes.</em></p>
</td>
</tr>
<tr>
<td valign="top" width="94">
<p>Transaction limit breached</p>
</td>
<td valign="top" width="94" >
<p>Yes</p>
</td>
<td valign="top" width="123">
<p>SD/MC</p>
</td>
<td valign="top" width="290">
<p>Transaction sent for in channel approval via the existing Transaction Approval screen</p>
<p><em style="color:#7CB9E8">Note: The debit amount, i.e., the combined total for that specific SD/MC transaction will be used to calculate the transaction amount for limit checking purposes</em><em>.</em></p>
</td>
</tr>
</tbody>
</table>
<p>Where a payment is sent for in channel approval, via the existing Transaction approvals screen, the approvers than can approve or reject the transaction will be determined via the payment workflow that has been set up for the channel. </p>
<u>Daily Transaction Limits</u>
<p>Once the per day limit has been set on a profile and a payment file submitted via this profile, we will check whether any transactions breach the daily limit.  This daily limit is a running total that is updated after each transaction has been submitted.  It will be checked each time a submission is made against the specific profile that has the limit set.  </p>
<p>The way these transactions are treated is shown in the table below.  </p>
<table class='table table-bordered '>
<tbody>
<tr>
<td valign="top" width="94" class='table-background'>
<p><strong>Limit</strong></p>
</td>
<td valign="top" width="94" class='table-background'>
<p><strong>Exceed with Approval Set</strong></p>
</td>
<td valign="top" width="123" class='table-background'>
<p><strong>Single Debit (SD) or Single Debit/Multi Credit (SD/MC)</strong></p>
</td>
<td valign="top" width="290" class='table-background'>
<p><strong>Treatment</strong></p>
</td>
</tr>
<tr>
<td valign="top" width="94" class="grey-colour">
<p>Daily limit breached</p>
</td>
<td valign="top" width="94" class="grey-colour">
<p>No</p>
</td>
<td valign="top" width="123" class="grey-colour">
<p>SD</p>
</td>
<td valign="top" width="290" class="grey-colour">
<p>Transaction Rejected</p>
</td>
</tr>
<tr>
<td valign="top" width="94" class="grey-colour">
<p>Daily limit breached</p>
</td>
<td valign="top" width="94" class="grey-colour">
<p>Yes</p>
</td>
<td valign="top" width="123"  class="grey-colour">
<p>SD</p>
</td>
<td valign="top" width="290" class="grey-colour">
<p>Transaction sent for in channel approval via the existing Transaction Approval screen.&nbsp;</p>
</td>
</tr>
<tr>
<td valign="top" width="94" class="grey-colour">
<p>Daily limit breached</p>
</td>
<td valign="top" width="94" class="grey-colour">
<p>No</p>
</td>
<td valign="top" width="123" class="grey-colour">
<p>SD/MC</p>
</td>
<td valign="top" width="290" class="grey-colour">
<p>Transaction Rejected</p>
<p><em style="color:#7CB9E8">Note: The debit amount, i.e., the combined total for that specific SD/MC transaction will be used to calculate the whether the transaction amount &nbsp;amount for limit checking purposes.</em></p>
</td>
</tr>
<tr>
<td valign="top" width="94" class="grey-colour">
<p>Daily limit breached</p>
</td>
<td valign="top" width="94" class="grey-colour">
<p>Yes</p>
</td>
<td valign="top" width="123" class="grey-colour">
<p>SD/MC</p>
</td>
<td valign="top" width="290" class="grey-colour">
<p>Transaction sent for in channel approval via the existing Transaction Approval screen</p>
<p><em style="color:#7CB9E8">Note: The debit amount, i.e., the combined total for that specific SD/MC transaction will be used to calculate the transaction amount for limit checking purposes</em><em>.</em></p>
</td>
</tr>
</tbody>
</table>
<p>Where a payment is sent for in channel approval, via the existing Transaction approvals screen, the approvers than can approve or reject the transaction will be determined via the payment workflow that has been set up for the channel. </p>
<p><u>Single Debit Multi Credit Payments</u></p>

<p>Single debit/multi credit payments can have between 2 and 1000 transaction included within the payment instruction.  We check the combined total of the SD/MC payment when reviewing limits.  This means that whilst there may only be certain transactions within this SD/MC payment that exceed the defined per transaction limit the whole payment will actually be pushed in channel for approval.  </p>
<p>Where a SD/MC payment has been made it is treated as one transaction, whether Batch booking has been set or not, until the payment has been approved.  This means that we use the overall debit amount when checking the transaction limits for these types of payments.  </p>
<p>Consideration should be given when setting these limits if SD/MC payments are going to be made given they may trigger more channel approvals that require action.</p>

<p><u>Approvals</u></p>
<p>The existing channel approvals screen will display any transactions that require approval.  </p>
<p>For API, CBD or SWIFT transactions that require an additional channel approval because of the limit and exceed with approval checks will be displayed along with payment created within the web channel.  The channel type column will confirm where they payment was initiated from.</p>
<p><img src='${process.env.PUBLIC_URL}/images/2/1/12.png'/></p>
`;


// WEBPACK FOOTER //
// ./src/components/content/UserRoleProfileData.ts